import React from 'react';

import SvgContainer from '../SvgContainer';

const Calendar = () => {
    return (
        <SvgContainer>
            <path d="M13.4444 1.6H12.6667V0.777779C12.6667 0.348224 12.3184 0 11.8889 0C11.4593 0 11.1111 0.348223 11.1111 0.777778V1.6H4.88889V0.777779C4.88889 0.348224 4.54067 0 4.11111 0C3.68156 0 3.33333 0.348223 3.33333 0.777778V1.6H2.55556C1.69222 1.6 1.00778 2.32 1.00778 3.2L1 14.4C1 15.28 1.69222 16 2.55556 16H13.4444C14.3 16 15 15.28 15 14.4V3.2C15 2.32 14.3 1.6 13.4444 1.6ZM13.4444 13.9C13.4444 14.1761 13.2206 14.4 12.9444 14.4H3.05556C2.77941 14.4 2.55556 14.1761 2.55556 13.9V6.1C2.55556 5.82386 2.77941 5.6 3.05556 5.6H12.9444C13.2206 5.6 13.4444 5.82386 13.4444 6.1V13.9ZM4.11111 8.2C4.11111 7.64772 4.55883 7.2 5.11111 7.2H7C7.55228 7.2 8 7.64772 8 8.2V10.2C8 10.7523 7.55228 11.2 7 11.2H5.11111C4.55883 11.2 4.11111 10.7523 4.11111 10.2V8.2Z" />
        </SvgContainer>
    );
};

export default Calendar;
